module.exports = __webpack_public_path__ + "img/2021_IMG-a52ea03ab76e413306170b951c7fd696-V.f9a2bd30.jpg";